import { render, staticRenderFns } from "./MyCarousel.vue?vue&type=template&id=7775ad40&"
import script from "./MyCarousel.vue?vue&type=script&lang=js&"
export * from "./MyCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MyCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports